import { types } from "../types/types";

const initialState = {
  cargada: false,
  items: [],
  loading: false,
  error: null,
};
export const empresasPreafiliadoReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.empresasPreafiliadoTraerStart:
      return {
        ...state,
        loading: true,
        error: null,
        cargada: false,
      };
    case types.empresasPreafiliadoTraerSuccess:
      return {
        ...state,
        loading: false,
        items: action.payload,
        cargada: true,
      };
    case types.empresasPreafiliadoTraerError:
      return {
        ...state,
        loading: false,
        error: action.payload,
        items: [],
        cargada: false,
      };
    case types.empresasPreafiliadoLimpiar:
      return {
        loading: false,
        items: [],
        cargada: false,
      };
    case types.empresasPreafiliadoInsertSuccess:
      return {
        loading: false,
        items: [action.payload, ...state.items],
        cargada: true,
      };
    case types.empresasPreafiliadoDeleted:
      return {
        ...state,
        cargada: true,
        items: state.items.filter(
          (item) => {
            return parseInt(item.idEmpresasAfiliados) !== parseInt(action.payload)
          }
        ),
      };
    case types.empresasPreafiliadoStartUpdate:
      return {
        ...state,
        cargada: false,
        error: null,
      };
    case types.empresasPreafiliadoUpdated:
      return {
        ...state,
        cargada: true,
        items: state.items.map((item) =>
          item.idEmpresasAfiliados === action.payload.idEmpresasAfiliados
            ? {
                ...item,
                empresa: action.payload.empresa,
                fechaDesde: action.payload.fechaDesde,
                fechaHasta: action.payload.fechaHasta,
              }
            : item
        ),
      };
     
    default:
      return state;
  }
};
